import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension'
import {
    AnyAction,
    applyMiddleware,
    CombinedState,
    createStore,
    Store,
    StoreEnhancer,
} from 'redux'
import createSagaMiddleware from 'redux-saga'
import thunk, { ThunkDispatch } from 'redux-thunk'

import reducers, { Reducers } from './reducers'
import rootSaga from './sagas'

const sagaMiddleware = createSagaMiddleware()

const createEnhancer = (): StoreEnhancer => (process.env.REACT_APP_APP_ENV !== 'production'
    ? composeWithDevToolsDevelopmentOnly(applyMiddleware(thunk, sagaMiddleware))
    : applyMiddleware(thunk, sagaMiddleware)
)

export const configureStore = async (preloadedState: Record<string, unknown> = {}): Promise<Store<CombinedState<Reducers>>> => {
    const enhancer = await createEnhancer()

    const store = createStore(reducers, preloadedState, enhancer)

    sagaMiddleware.run(rootSaga)

    return store
}

export type TypedDispatch = ThunkDispatch<Reducers, unknown, AnyAction>;
export const useTypedDispatch = (): TypedDispatch => useDispatch<TypedDispatch>()
export const useTypedSelector: TypedUseSelectorHook<Reducers> = useSelector
